import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const constantRoutes = [
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import('@/pages/404.vue')
  },
  {
    path: '/',
    name: 'main',
    component: () => import('@/pages/Main'),
    children: [
      {
        path: '/login-in',
        name: 'login-in',
        component: () => import('@/pages/LoginIn')
      },
      {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import('@/pages/SignUp')
      },
      {
        path: '/',
        name: 'home',
        component: () => import('@/pages/Home')
      },
      {
        path: '/song-list',
        name: 'song-list',
        component: () => import('@/pages/SongList')
      },
      {
        path: '/my-music',
        name: 'my-music',
        component: () => import('@/pages/MyMusic')
      },
      {
        path: '/song-list-album/:id',
        name: 'song-list-album',
        component: () => import('@/pages/SongListAlbum')
      },
      {
        path: '/memberList',
        name: 'memberList',
        component: () => import('@/pages/MemberList')
      },
      {
        path: '/member-info/:id',
        name: 'member-info',
        component: () => import('@/pages/MemberInfo')
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import('@/pages/AboutUs')
      },
      {
        path: '/vip',
        name: 'vip',
        component: () => import('@/pages/Vip')
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/pages/Search')
      },
      {
        path: '/setting',
        name: 'setting',
        component: () => import('@/pages/Setting')
      }
    ]
  }
]

export default new Router({
  mode: 'hash', // 去掉url中的#
  scrollBehavior: (o, from, savedPosition) => ({ x: 0, y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js